/* eslint @typescript-eslint/no-explicit-any: 0 */
import Tracked from '~/components/Tracked';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import { brandLogos } from '../brandLogos';
import MenuLink from '../MenuLink';
import type { MenuItemProps } from '../types';

export default function MegaNavClothingItem({
  link,
  name,
  content,
  pagePosition,
  position = 1
}: MenuItemProps) {
  const fireNavigationLink = useNavigationLinkInteraction('meganav');
  const featuredBrandsLabel = 'Featured brands';

  const FeaturedBrands = content?.footwear?.featuredBrands?.children?.map(
    (item: any, i: number) => {
      const { icon, name: brandName, viewAll, path } = item;
      const href = `${path}${viewAll?.link || ''}`;

      return (
        <div key={i} className="size-20">
          <Tracked.ExternalLink
            variant="none"
            pagePosition="Header"
            name={brandName as TrackedButtonClickName}
            href={href}
            onClick={() =>
              fireNavigationLink(href, i + 1, {
                ancestorLabels: [name, featuredBrandsLabel],
                label: brandName
              })
            }
          >
            <img
              alt={brandName}
              src={brandLogos[icon]}
              loading="lazy"
              className="size-20"
            />
          </Tracked.ExternalLink>
        </div>
      );
    }
  );

  return (
    <li className="group flex h-[50px] grow justify-center whitespace-nowrap">
      <Tracked.ExternalLink
        variant="none"
        pagePosition="Header"
        name={name as TrackedButtonClickName}
        href={link}
        className="flex w-full shrink-0 items-center justify-center px-[10px] py-4 font-heading text-[15px] font-medium tracking-[0.4px] text-white hover:rounded-md hover:bg-grey-dark max-[1199.98px]:w-fit"
        onClick={() =>
          fireNavigationLink(link, position, {
            ancestorLabels: [],
            label: name
          })
        }
      >
        {name}
      </Tracked.ExternalLink>
      {content?.render ? (
        <div className="absolute left-0 top-[60px] hidden max-h-[calc(100vh-60px)] w-full overflow-y-hidden shadow-[0px_5px_5px_-3px_rgba(0,0,0,0.18)] group-hover:block">
          <div className="h-[10px]"></div>
          <div className="max-h-[calc(100vh-70px)] w-full overflow-auto bg-white">
            <div className="content-width pb-12 pt-8">
              <div>
                <div className="flex flex-row gap-6 pb-6">
                  <div className="text-title-sm">
                    {content?.footwear?.title}
                  </div>
                  <div className="flex gap-4">
                    {content?.footwear?.filters.map(
                      (item: MenuItemProps, i: number) => (
                        <MenuLink
                          key={i}
                          title={item?.title}
                          link={item?.link}
                          pagePosition={pagePosition}
                          onClick={() =>
                            fireNavigationLink(item?.link, i + 1, {
                              ancestorLabels: [name],
                              label: item?.title
                            })
                          }
                        />
                      )
                    )}
                  </div>
                </div>

                {content?.footwear?.featuredBrands && (
                  <div className="flex flex-col gap-6">
                    <div className="text-title-sm">{featuredBrandsLabel}</div>

                    <div className="grid w-full grid-cols-[repeat(6,auto)] justify-between gap-y-6">
                      {FeaturedBrands}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </li>
  );
}
